import { Box, Flex, SwitchWithLabels } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import Select from '../../../../../../components/common/select/Select'
import { css } from '@emotion/react'
import React, { useEffect, useState } from 'react'
import {
  getEnrolmentCreatedByOptionsMap,
  transformToSelectOptions
} from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/CampaignAudienceHelpers'
import {
  CampaignEnrolmentFilterSetupInput,
  EnrolmentCreationMethodEnum,
  TargetEnrolmentStatusEnum
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useEditCampaignFilterContext } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/enrolment-modal/EditCampaignFilterContext'

export const EditCampaignEnrolmentCreatedByRow = () => {
  const { editedFilter, setEditedFilter } = useEditCampaignFilterContext()
  const selectedStatus = editedFilter.enrolmentFilterSetup?.enrolmentFilterType
  const isLastViewed =
    selectedStatus === TargetEnrolmentStatusEnum.last_viewed_at

  const [enrolmentCreatedBy, setEnrolmentCreatedBy] =
    useState<EnrolmentCreationMethodEnum>(
      editedFilter.enrolmentFilterSetup?.creationMethod ||
        EnrolmentCreationMethodEnum.shareOrSelfAssign
    )
  const [includeArchived, setIncludeArchived] = useState(
    editedFilter.enrolmentFilterSetup?.includeArchived || false
  )

  const createdByArchivedData = !isLastViewed
    ? {
        includeArchived,
        creationMethod: enrolmentCreatedBy
      }
    : null

  useEffect(() => {
    setEditedFilter({
      ...editedFilter,
      enrolmentFilterSetup: {
        ...editedFilter.enrolmentFilterSetup,
        ...createdByArchivedData
      } as CampaignEnrolmentFilterSetupInput
    })
  }, [enrolmentCreatedBy, includeArchived])

  const enrolmentCreatedByOptions = transformToSelectOptions(
    getEnrolmentCreatedByOptionsMap()
  )

  return (
    <Flex align="center" mt="32px">
      <Box mr="16px" textAlign="right" w="162px">
        <Trans>Enrolment created by</Trans>
      </Box>

      <Box mr="16px">
        <Select
          css={css`
            .Select__control {
              min-width: 188px;
            }
          `}
          options={enrolmentCreatedByOptions}
          value={enrolmentCreatedByOptions.find(({ value }) => {
            return value === enrolmentCreatedBy
          })}
          onChange={(option) => {
            setEnrolmentCreatedBy(option?.value)
          }}
        />
      </Box>

      <Flex>
        <Box mr="16px">
          <Trans>including archived</Trans>
        </Box>

        <SwitchWithLabels
          onChange={() => {
            setIncludeArchived(!includeArchived)
          }}
          isChecked={includeArchived}
        />
      </Flex>
    </Flex>
  )
}
